import React, {useMemo} from 'react';
import {Button} from 'antd';
import {useTranslation} from 'react-i18next';
import {SorterPlanFiltersType} from "../hooks/useSorterPlanQuery";
import ParcelFilterStyle from "../../../delivery/components/ParcelFilterStyle";
import {getSmartLabelClassName} from "../../../../utils/labelWidthUtils";

interface SorterPlanFilterProps {
    filters: SorterPlanFiltersType;
    setFilters: (filters: SorterPlanFiltersType) => void;
    handleFilter: () => void;
    handleResetFilters: () => void;
    onAddSorterPlan: () => void;
}

const SorterPlanFilter: React.FC<SorterPlanFilterProps> = ({
    filters,
    setFilters,
    handleFilter,
    handleResetFilters,
    onAddSorterPlan,
}) => {
    const {t} = useTranslation();

    // 设备类型选项
    const sorterTypeOptions = useMemo(() => [
        {value: '', label: t('wms.sorterPlan.filters.allTypes')},
        {value: '1', label: 'DWS'},
        {value: '2', label: t('wms.sorterPlan.filters.crossBelt')}
    ], [t]);

    // 状态选项
    const statusOptions = useMemo(() => [
        {value: '', label: t('common.all')},
        {value: '0', label: t('wms.sorterPlan.status.unused')},
        {value: '1', label: t('wms.sorterPlan.status.inUse')}
    ], [t]);

    // Label constants for alignment
    const labelDeviceType = String(t('wms.sorterPlan.filters.deviceType'));
    const labelStatus = String(t('wms.sorterPlan.filters.status'));

    // Calculate label width for column alignment
    const col1Labels = [labelDeviceType];
    const col2Labels = [labelStatus];

    const col1SpanClassName = getSmartLabelClassName(col1Labels);
    const col2SpanClassName = getSmartLabelClassName(col2Labels);

    // 处理设备类型变化
    const handleSorterTypeChange = (value: string) => {
        setFilters({...filters, sorterType: value ? parseInt(value) : undefined});
    };

    // 处理状态变化
    const handleStatusChange = (value: string) => {
        setFilters({...filters, status: value ? parseInt(value) : undefined});
    };

    return (
        <div className="mb-2 pl-0 py-2">
            {/* 使用 Grid 布局确保列对齐 */}
            <div className="grid grid-cols-3 gap-x-10 gap-y-4 items-start">
                {/* 设备类型筛选 */}
                <div className="min-w-0">
                    <ParcelFilterStyle
                        label={labelDeviceType}
                        value={filters.sorterType !== undefined ? filters.sorterType.toString() : ''}
                        onChange={handleSorterTypeChange}
                        options={sorterTypeOptions}
                        spanClassName={col1SpanClassName}
                    />
                </div>

                {/* 状态筛选 */}
                <div className="min-w-0">
                    <ParcelFilterStyle
                        label={labelStatus}
                        value={filters.status !== undefined ? filters.status.toString() : ''}
                        onChange={handleStatusChange}
                        options={statusOptions}
                        spanClassName={col2SpanClassName}
                    />
                </div>
            </div>

            {/* 操作按钮 */}
            <div className="flex justify-end gap-3 mt-4">
                <Button
                    type="primary"
                    onClick={onAddSorterPlan}
                    className="font-semibold min-w-[100px]"
                >
                    {t('wms.sorterPlan.buttons.addSorterPlan')}
                </Button>
                <Button type="primary" onClick={handleFilter} className="font-semibold min-w-[80px]">
                    {t('wms.sorterPlan.buttons.filter')}
                </Button>
                <Button onClick={handleResetFilters} className="font-semibold min-w-[80px]">
                    {t('wms.sorterPlan.buttons.reset')}
                </Button>
            </div>
        </div>
    );
};

export default SorterPlanFilter;
